import { makeObservable, observable, action, reaction } from 'mobx';
import axios, { storeGet } from "../utils/axios";
import generateUid from "../utils/generateUid";

class appStateStore {
  /*me={ fetching: false,inited: false,data:{},};*/
  grid_mode="";
  site_tpl="";
  webp_support=null;
  editor_mode=false;
  show_mobile_menu=false;
  par=null;
  global_errors=[];
  app_visible=true;
  gmt_list={ fetching: false,inited: false, data:{}};
  countries={ fetching: false,inited: false, data:{}};

  fetchGmt() {
    storeGet('/api/gmt', this.gmt_list, true);
  }
  fetchCountries() {
    storeGet('/api/countries', this.countries, true)
  }
  pushGlobalErrors(errors) {
    let uids=[];
    for(let i in errors) {
      errors[i].uid=generateUid();
      uids.push(errors[i].uid);
      this.global_errors.push(errors[i]);
    }

    setTimeout(()=>{
      while(true) {
        let wasDeleted=false;
        for (let i in this.global_errors) {
          if(uids.indexOf(this.global_errors[i].uid) > -1) {
            this.global_errors.splice(parseInt(i),1);
            wasDeleted=true;
            break;
          }
        }
        if(!wasDeleted) {
          break;
        }
      }
    },5000);

  }
  constructor(par) {
    this.par=par;
    makeObservable(this, {
      grid_mode: observable,
      webp_support: observable,
      editor_mode: observable,
      site_tpl: observable,
      global_errors: observable,
      gmt_list: observable,
      countries: observable,
      app_visible: observable,
    });
  }

}

/*
decorate(switchStore,{
  editor_mode:observable,
});
*/

export default appStateStore;
